import Slider from 'components/slider';

const simpleSliders = document.querySelectorAll('.j-simple-slider');

if (simpleSliders.length) {
    simpleSliders.forEach((slider) => {
        new Slider({
            elem     : slider.querySelector('.j-simple-slider__slides'),
            controls : slider.querySelector('.j-simple-slider__controls'),
            prevArrow: slider.querySelector('.j-slider__prev'),
            nextArrow: slider.querySelector('.j-slider__next'),
            settings : {
                dots      : true,
                infinite  : true,
                fade      : true,
                speed     : 500,
                responsive: [{
                    breakpoint: 960,
                    settings  : {
                        arrows: false
                    }
                }]
            }
        }).init();
    });
}
